import React, { useEffect } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import { CardMedia } from "@mui/material";
import { urlRoot } from "../global";

function Navbar({ tituloEvento, nivel }) {
  var ruta = window.location.origin;
  var palabra = "localhost";

  var index = ruta.indexOf(palabra);
  if (index < 0) ruta = ruta + "/" + urlRoot;

  useEffect(() => {
    let tituloEventoTxt = tituloEvento;
    let nivelTitle;
    if (nivel === "profesional") nivelTitle = "Profesional";
    else nivelTitle = "PrepaTec";

    if (tituloEvento === undefined) tituloEventoTxt = "Evento no encontrado";

    document.title = `${tituloEventoTxt} | ${nivelTitle}`;
  }, [tituloEvento, nivel]);

  const logoNivel = nivel || "profesional";

  return (
    <AppBar
      position="static"
      sx={{
        backgroundColor: "#000000",
        color: "#ffffff",
        boxShadow: "none",
      }}
    >
      <Toolbar
        disableGutters
        sx={{
          justifyContent: "center",
          minHeight: { xs: 56, md: 64 },
          py: 1,
        }}
      >
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <a href={"" + ruta + "/internacional"} rel="noopener noreferrer">
            <CardMedia
              component="img"
              sx={{
                height: { xs: 36, md: 42 },
                width: "auto",
                maxWidth: logoNivel === "prepatec" ? 195 : 160,
                filter: "brightness(0) invert(1)",
              }}
              image={`${ruta}/img/logo-${logoNivel}.svg`}
              alt={
                logoNivel === "prepatec"
                  ? "PrepaTec"
                  : "Tecnológico de Monterrey"
              }
            />
          </a>
        </Box>
      </Toolbar>
    </AppBar>
  );
}

export { Navbar };
